import { render, staticRenderFns } from "./TasksTab.vue?vue&type=template&id=72ca892c&scoped=true&"
import script from "./TasksTab.vue?vue&type=script&lang=js&"
export * from "./TasksTab.vue?vue&type=script&lang=js&"
import style0 from "./TasksTab.vue?vue&type=style&index=0&id=72ca892c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca892c",
  null
  
)

export default component.exports